import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Sahil Chandel</span>,
            <br />I have recently completed my B.Tech in Computer Science and Engineering from National Institute of Technology Hamirpur. I have an overall CGPI of 9.03.
            Currently, I'm working in Paytm as Software Engineer since June, 2022. I have also completed my internship of 6 months in Paytm since January to June and summer internship in 2021 from Innovaccer as Software Development Engineer.
            I like to learn new techs, tackle complex challenges head-on to deliver technically sound solutions with optimum efficiency.
          </p>
          {/* <ul>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Reading Harry Potter
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Travelling
            </li>
          </ul> */}


        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
